<script>
export default {
  install(Vue) {
    Vue.prototype.$showFormErrors = function(obj, messages) {
      for (var key in messages) {
        if (Object.prototype.hasOwnProperty.call(messages, key)) {
          this.$set(obj, key, messages[key]);
        }
      }
    };
    Vue.prototype.$clearFormErrors = function(obj) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          this.$set(obj, key, []);
        }
      }
    };
    Vue.prototype.$countFormErrors = function(messages, keys) {
      var count = 0;
      var recursive = (objs, parentKey) => {
        for (var key in objs) {
          var obj = objs[key];
          if (Array.isArray(obj)) {
            if (obj && obj.length && (!keys || (keys.length && (keys.indexOf(key) !== -1 || (parentKey && keys.indexOf(parentKey) !== -1))))) {
              count += obj.length;
            }
          } else if (typeof obj == "object") {
            recursive(obj, parentKey ? parentKey : key);
          }
        }
      };
      recursive(messages);
      return count;
    };
  }
}
</script>
